import {
  CampaignFilterByViewInput,
  type FilterColumnInputType,
  TrafficCampaignsSortByInput,
  useTrafficCampaignsLazyQuery,
} from 'generated/graphql';
import { useEffect, useMemo } from 'react';
import {
  convertTrafficCampaignsToTableData,
  getPreviewCampaignTypeLabels,
  getTrafficDisplayLandingPagePreviewCampaigns,
} from './advanced-preview-campaigns.util';

export type UseLandingPagePreviewCampaignsProps = {
  trafficProjectId: string;
  openModal: boolean;
};

const useLandingPagePreviewCampaigns = ({ openModal, trafficProjectId }: UseLandingPagePreviewCampaignsProps) => {
  const [getTrafficCampaigns, { data: allTrafficCampaigns, loading: trafficCampaignsLoading, error: trafficCampaignsError }] =
    useTrafficCampaignsLazyQuery({
      variables: {
        filterByView: CampaignFilterByViewInput.Active,
        filterColumnMap: {
          campaignType: getPreviewCampaignTypeLabels(),
        } as FilterColumnInputType,
        first: 300,
        includeLegacy: true,
        loadFromSymphony: false,
        projectId: trafficProjectId,
        sortOptions: {
          ascending: false,
          sortBy: TrafficCampaignsSortByInput.ModifiedAt,
        },
      },
    });

  useEffect(() => {
    if (openModal) {
      getTrafficCampaigns();
    }
  }, [
    getTrafficCampaigns,
    openModal,
  ]);

  const trafficDisplayCampaigns = useMemo(() => {
    if (!allTrafficCampaigns) return [];
    const trafficCampaigns = allTrafficCampaigns.trafficProject.campaigns.edges.map((edge) => edge.node);
    return getTrafficDisplayLandingPagePreviewCampaigns(trafficCampaigns);
  }, [
    allTrafficCampaigns,
  ]);

  const trafficCampaignsTableData = useMemo(() => {
    if (!trafficDisplayCampaigns) return [];
    return convertTrafficCampaignsToTableData(trafficDisplayCampaigns);
  }, [
    trafficDisplayCampaigns,
  ]);

  return {
    trafficCampaignsError,
    trafficCampaignsLoading,
    trafficCampaignsTableData,
    trafficDisplayCampaigns,
  };
};

export { useLandingPagePreviewCampaigns };
